export const isMediaDevicesEnabledSelector = state => state.application.isMediaDevicesEnabled;
export const requiresPermissionRequestSelector = state => state.application.requiresPermissionRequest;
export const modalOpeningCountSelector = state => state.application.modalOpeningCount;
export const languageSelector = state => state.application.language;
export const returnToSelector = state => state.application.returnTo;
export const isLightRegistrationSelector = state => state.application.isLightRegistration;
